export default __webpack_public_path__ + "static/media/marko_l.e7acaaab.jpg";